import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-pearl-light border-y border-pearl-dark" data-id="element-85" data-mp="1hbguwe4orz4a">
      <div className="max-w-3xl mx-auto" data-id="element-86" data-mp="1cg1ebefanp46">
        <div className="text-center mb-16" data-id="element-87" data-mp="2a1yuh567bicy">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy" data-id="element-88" data-mp="2a0xeqne8q7ow">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-89" data-mp="2042ikb5fwjds">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="bg-white border border-pearl-dark rounded-xl overflow-hidden" data-id="element-90" data-mp="1v46ekbwqsry8" data-mpi={index}>
                <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} data-id="element-91" data-mp="jpswxosl18qn">
                  <span className="font-bold text-lg text-navy" data-id="element-92" data-mp="1aor8vw4gvgdu">{faq.q}</span>
                  {isOpen ? <MinusIcon className="text-gold-dark shrink-0" size={20} data-id="element-93" data-mp="1fn2ic5qunovj" /> : <PlusIcon className="text-gold-dark shrink-0" size={20} data-id="element-94" data-mp="11vxppnlwfwup" />}
                </button>
                <AnimatePresence initial={false} data-id="element-95" data-mp="16ps72ke17zqm">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-96" data-mp="s0vzspjsuqr2">
                      <div className="px-6 pb-5 text-graphite border-t border-pearl-dark pt-4" data-id="element-97" data-mp="2pmwybu4tulal">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}